import React from 'react';
import './ImageModal.css';

const ImageModal = ({ image, onClose, onDownload }) => {
  if (!image) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <div className="modal-body">
          <div className="modal-image-container">
            <img src={image.imageUrl} alt="Transformed" />
          </div>
          <div className="modal-actions">
            <button onClick={onDownload} className="modal-download-btn">
              Download Image
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
